module.exports = __webpack_public_path__ + "img/pro-photo15.59d6bc38.jpg";